<div class="modal-header">
  <h4 class="modal-title">
    Nuevo reporte
  </h4>
  <button 
    type="button" 
    class="btn-close" 
    aria-label="Close" 
    (click)="activeModal.dismiss('Cross click')">
  </button>
</div>

<div class="modal-body">
  @if (!loading) {
    <form
      id="formReport"
      [formGroup]="formReport"
      (ngSubmit)="onSubmit()">
      <div class="container-fluid">
        <div class="row">

          @if(uploadedFiles.length > 0) {

            <div class="col-12 mb-3">
              <label for="uploadedImages" class="form-label">Imágenes cargadas</label>
              <div id="uploadedImages" class="d-flex flex-wrap">
                <div *ngFor="let file of uploadedFiles; let i = index" class="p-2 position-relative">
                    <img *ngIf="file.startsWith('data:image/')" [src]="file" alt="Imagen cargada" class="img-thumbnail" style="max-width: 150px; max-height: 150px;">
                    <button 
                    type="button" 
                    class="btn btn-danger btn-sm position-absolute top-0 end-0 m-1 rounded-circle" 
                    (click)="uploadedFiles.splice(i, 1)">
                      <i class="material-icons mt-1">close</i>
                    </button>
                </div>
              </div>
            </div>

          }

          <div 
            class="col-12 vh-30 bg-tertiary bg-center d-flex align-items-center justify-content-center mt-2">
            <button 
              class="btn btn-primary px-5 py-2 mb-5 w-100"
              type="button"
              (click)="compressFile()">
              Subir fotos
            </button>
          </div>

          @for (key of utilService.objectKeys(dataForm); track key) {
            @if (
              dataForm[key].type != "select" && 
              dataForm[key].type != "switch" &&
              dataForm[key].type != "textarea" &&
              dataForm[key].type != "image"
            ) {
              <div class="col-12 form-group mb-4">
                <label [htmlFor]="key" class="form-label">
                  {{ dataForm[key].label }}
                </label>
                <input
                  [type]="dataForm[key].type"
                  class="form-control"
                  formControlName="{{ key }}"
                  [placeholder]="dataForm[key].placeholder ?? dataForm[key].label"
                  [ngClass]="{
                    'is-invalid': submitted && f[key].errors
                  }">
                  @if (submitted && f[key].errors && dataForm[key].required) {
                    <div class="invalid-feedback">
                      @if (f[key].errors!['required']) {
                        <div>{{ dataForm[key].requiredMessage }}</div>
                      }
                    </div>
                  }
              </div>
            }

            @if (dataForm[key].type === 'select') {
              <div class="mb-4">
                <div class="mb-1">
                  {{ dataForm[key].label }}
                </div>
                <ng-select
                  [items]="dataForm[key].data!"
                  [bindLabel]="dataForm[key].labelSelect!"
                  [bindValue]="dataForm[key].idSelect!"
                  formControlName="{{ key }}"
                  [placeholder]="dataForm[key].placeholder ?? ''"
                  (ngModelChange)="dataForm[key].onChange ? dataForm[key].onChange!($event) : null">
  
                </ng-select>
                @if (submitted && f[key].errors && dataForm[key].required) {
                  <div class="text-danger">
                    @if (f[key].errors!['required']) {
                      {{ dataForm[key].requiredMessage }}
                    }
                  </div>
                }
              </div>
            }

            @if (dataForm[key].type === 'textarea') {
              <div class="col-12 form-group mb-4">
                <label [htmlFor]="key" class="form-label">
                  {{ dataForm[key].label }}
                </label>
                <textarea
                  class="form-control"
                  formControlName="{{ key }}"
                  [placeholder]="dataForm[key].placeholder ?? dataForm[key].label"
                  [ngClass]="{
                    'is-invalid': submitted && f[key].errors
                  }"></textarea>
                  @if (submitted && f[key].errors && dataForm[key].required) {
                    <div class="invalid-feedback">
                      @if (f[key].errors!['required']) {
                        <div>{{ dataForm[key].requiredMessage }}</div>
                      }
                    </div>
                  }
              </div>
            }

          }

        </div>
      </div>
    </form>
  }
</div>

<div class="modal-footer">

  <div class="col-12 my-2">
    <button
      (click)="activeModal.close()"
      type="button"
      class="btn btn-outline-danger w-100">
      Cancelar
    </button>
  </div>
  <div class="col-12">
    <button
      type="submit"
      form="formReport"
      class="btn btn-success w-100">
      Registrar
    </button>
  </div>

</div>
